// @flow
import axios from 'axios';

import type { Untranslated } from '@rover/shared/js/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';
import parseApiErrors from '@rover/utilities/parseApiErrors';
import { camelize } from '@rover/utilities/object-utilities';
import type { PaymentIntentResponse } from '../types';
import APIError from './APIError';

export class PaymentIntentCreationError extends APIError {
  type: string = 'PaymentIntentCreationError';
  errorType: ?string = null;

  constructor(message: Untranslated, status: number, errorType: ?string) {
    super(message, status);
    this.errorType = errorType;
  }
}

export const PAYMENT_INTENT_URL = fullApiUrl('payment-intents/');

export const post = async (
  conversationOpk: string,
  ccmUrl: string,
  amount: number,
  currency: string
): Promise<PaymentIntentResponse> => {
  try {
    const response = await axios.post(PAYMENT_INTENT_URL, {
      amount,
      currency,
      credit_card_method: ccmUrl,
      conversation: conversationOpk,
    });
    const { data } = response;
    return camelize(data, true);
  } catch (e) {
    const { response } = e;
    const errors = parseApiErrors(response);
    // placeholder error for now until we decide more granular error for FE payment intent
    const message = errors.length ? errors.pop() : 'There was an error creating payment intent.';

    // placeholder error for now until we decide more granular
    // error for FE payment intent
    // limit Payment Intent errors to the payment_intent_creation to avoid
    // accidently displaying untranslated strings
    throw new PaymentIntentCreationError(
      message,
      response.status,
      response.data && response.data.error_type
    );
  }
};



// WEBPACK FOOTER //
// ../react-lib/src/apis/paymentIntent.api.js